import React from "react";
import { brand } from "../theme/brand.js";
import { ServiceCard } from "./ServiceCard.jsx";

export function ServiceSection({ title, description, items, startIndex = 0, onStartService }) {
  return (
    <div style={{ marginBottom: "8px" }}>
      <div style={{ marginBottom: "18px" }}>
        <h2 style={{ margin: "0 0 4px 0", fontSize: "17px", fontWeight: "700", color: brand.prussianBlue, fontFamily: brand.font, letterSpacing: "-0.01em" }}>
          {title}
        </h2>
        <p style={{ margin: 0, fontSize: "13px", color: brand.textSecondary, fontFamily: brand.font }}>
          {description}
        </p>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "16px" }}>
        {items.map((service, i) => (
          <ServiceCard key={service.id} service={service} entranceIndex={startIndex + i} onStartService={onStartService} />
        ))}
      </div>
    </div>
  );
}
